import { buildTechTaskCompletionDisplay, normalizeBatchProgressFromCounts } from './taskProgress';

const LABELS_BY_NAV = {
  stampExtract: {
    successStatusKey: 'extractDone',
    partialStatusKey: 'extractPartial',
    terminatedStatusKey: 'extractTerminated',
    waitingStatusKey: 'extractWaiting',
    processingStatusKey: 'extractProcessing',
    failedStatusKey: 'extractFailed',
  },
  imageEnhance: {
    successStatusKey: 'enhanceDone',
    partialStatusKey: 'enhancePartial',
    terminatedStatusKey: 'enhanceTerminated',
    waitingStatusKey: 'enhanceWaiting',
    processingStatusKey: 'enhanceProcessing',
    failedStatusKey: 'enhanceFailed',
  },
  smartCutout: {
    successStatusKey: 'cutoutDone',
    partialStatusKey: 'cutoutPartial',
    terminatedStatusKey: 'cutoutTerminated',
    waitingStatusKey: 'cutoutWaiting',
    processingStatusKey: 'cutoutProcessing',
    failedStatusKey: 'cutoutFailed',
  },
};

const DEFAULT_LABELS = {
  successStatusKey: 'doneGeneric',
  partialStatusKey: 'partialDone',
  terminatedStatusKey: 'processTerminated',
  waitingStatusKey: 'processWaiting',
  processingStatusKey: 'processingGeneric',
  failedStatusKey: 'failedGeneric',
};

export function getImageProcessStudioTaskCompletionDisplay(task, navId = '') {
  const labels = LABELS_BY_NAV[navId] || DEFAULT_LABELS;
  return buildTechTaskCompletionDisplay(normalizeBatchProgressFromCounts(task), labels);
}
